import React from 'react';

const Background: React.FC = () => (
  <div className="background">
    <svg viewBox="0 0 1924 951" fill="none">
      <g clipPath="url(#clip0)">
        <path fill="#F2F5FA" fillRule="evenodd" d="M0 899h1924V0H0v899z" clipRule="evenodd" />
        <path
          fill="#FAFBFC"
          fillRule="evenodd"
          d="M0 950V537s495-223 1063 37c568 259 861 294 861 294v83L0 950z"
          clipRule="evenodd"
        />
        {/* <path
          stroke="#E3E7EC"
          strokeWidth="1"
          d="M-3 505c57-31 177-80 437-95 319-18 583 70 968 62 278-5 464-91 525-158"
        /> */}
      </g>
    </svg>
  </div>
);

export default React.memo(Background);
